<template>
  <div id="appmanage">
    <div class="button-group">
      <div class="button-title">应用列表</div>
      <div class="filling"></div>
      <el-input
        size="small"
        placeholder="请输入应用名"
        v-model="filterValue"
        class="filter-input"
        @keyup.enter.native="onSubmit"
      >
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="onSubmit"
        ></el-button>
      </el-input>
      <el-button
        type="primary"
        size="small"
        @click="newApp"
        style="margin-left: 10px;"
        >新建应用</el-button
      >
    </div>
    <el-table
      v-loading="loading"
      :data="tableData"
      height="calc(100% - 32px - 32px - var(--padding))"
    >
      <el-table-column prop="name" label="应用名" min-width="140">
      </el-table-column>
      <el-table-column prop="appCode" label="应用编码" min-width="110">
      </el-table-column>
      <el-table-column prop="ownerName" label="所有者" min-width="110">
      </el-table-column>

      <el-table-column prop="taskCount" label="流程数" min-width="90">
        <template slot-scope="scope">
          <span class="path" @click="toFlow(scope.row)">{{
            scope.row.taskCount
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="variableCount" label="变量数" min-width="90">
        <template slot-scope="scope">
          <span class="path" @click="toVar(scope.row)">{{
            scope.row.variableCount
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="描述" min-width="220">
      </el-table-column>
      <el-table-column prop="crateTime" label="创建时间" min-width="180">
      </el-table-column>
      <el-table-column prop="startTime" label="操作" width="90">
        <template slot-scope="scope">
          <el-tooltip
            content="修改"
            :visible-arrow="false"
            placement="top"
            effect="light"
            :open-delay="1000"
            :enterable="false"
            :hide-after="2500"
            transition="el-fade-in"
            popperClass="tooltip-config"
          >
            <i
              class="el-icon-ga-bianji icon-button"
              @click="setApp(scope.row)"
            ></i>
          </el-tooltip>
          <el-tooltip
            content="删除"
            :visible-arrow="false"
            placement="top"
            effect="light"
            :open-delay="1000"
            :enterable="false"
            :hide-after="2500"
            transition="el-fade-in"
            popperClass="tooltip-config"
          >
            <i
              class="el-icon-ga-shanchu delete-icon icon-button"
              @click="deleteApp(scope.row)"
            ></i>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <page-trun
      :disabled="loading"
      :page="page"
      :queryData="queryData"
      :path="`${KeyWorld}_`"
      @pageTrun="pageTrun"
    />
    <app-dialog
      :dialog.sync="dialog"
      :dialogData="dialogData"
      @refush="getData"
    />
  </div>
</template>

<script>
import appDialog from "./dialog.vue";
import { Delete } from "@/utils/index";
export default {
  name: "appmanage",
  data() {
    return {
      loading: false,
      dialog: false,
      dialogData: null,
      queryData: {},
      activeTab: 0,
      editableTabs: [],
      filterValue: "",
      KeyWorld: "",
      page: {
        pageIndex: 1,
        hasMore: false,
        limit: 20
      }
    };
  },
  computed: {
    tableData() {
      return this.queryData[`${this.KeyWorld}_${this.page.pageIndex}`];
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      this.$http
        .get(
          "/gavial/v1/app/list?pageIndex=" +
            this.page.pageIndex +
            "&keyWord=" +
            this.KeyWorld
        )
        .then(res => {
          this.$set(
            this.queryData,
            `${this.KeyWorld}_${res.data.pageIndex}`,
            res.data.data
          );
          this.page.pageIndex = res.data.pageIndex;
          this.page.hasMore = res.data.hasMore;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    newApp() {
      this.dialogData = null;
      this.dialog = true;
    },
    setApp(row) {
      this.dialogData = row;
      this.dialog = true;
    },
    deleteApp(row) {
      Delete(
        `/gavial/v1/app/del?appId=${row.appId}`,
        row.name,
        this.refush,
        bool => {
          this.loading = bool;
        }
      );
    },
    refush() {
      this.queryData = {};
      this.page.pageIndex = 1;
      this.page.hasMore = false;
      this.getData();
    },
    onSubmit() {
      this.KeyWorld = this.filterValue;
      this.getData();
    },
    toVar(row) {
      this.$router.push({
        path: "/flowmanage/varmanage",
        query: {
          name: row.name,
          appId: row.appId
        }
      });
    },
    toFlow(row) {
      this.$router.push({
        path: "/flowmanage/flowInfo",
        query: {
          appId: row.appId,
          ownerId: row.ownerId + "",
          name: row.name
        }
      });
    },
    pageTrun(i) {
      this.page.pageIndex = i;
      if (!this.queryData[`${this.KeyWorld}_${this.page.pageIndex}`]) {
        this.getData();
      }
    }
  },
  components: {
    appDialog
  }
};
</script>

<style lang="scss">
#appmanage {
  height: calc(100% - var(--padding) * 2);
  padding: var(--padding);
  background: #ffffff;
  .content {
    height: 100%;
  }
}
</style>
